import API from '../../../api/api';
import doMetric from '../../../tracking/bigQueryMetricRecorder';
import Track from '../../../utils/tracking';

function isTokenReceived(status) {
  return status === 'FLEX_TOKEN_RECEIVED';
}

function isReturningFromHostedPage() {
  return window.start.selectedPaymentMethod === 'FLEX';
}

function isProblemWithService(status) {
  return (status === 'HOSTED_PAYMENT_AUTHENTICATION_FAILED'
    || status === 'HOSTED_PAYMENT_CURRENTLY_UNAVAILABLE');
}

function returnedFromHostedPage() {
  try {
    doMetric('FlexPayProcessor', [{name: 'status', value: 'SUCCESS'}], [], 'impression');
  } catch (error) {
    Track.track(error);
  }
  
  return API.doAPIRequest(`/v2/return-from-hosted/flex`);
}

export default {
  isTokenReceived, isProblemWithService, isReturningFromHostedPage, returnedFromHostedPage,
};
